import { Alert, Snackbar, SnackbarCloseReason } from "@mui/material";
import { useApiError } from "../../hook/useApiError";
import { CommonSnackbar } from "../../../explorer/components/SnackBar/CommonSnackbar";
import { useApiNotification } from "../../hook/useApiNotification";
import { useApiPersistNotification } from "../../hook/useApiPersistNotification";
import { useApiWarning } from "../../hook/useApiWarning";

const AppSnackBar = () => {
    const [error, setError] = useApiError();
    const [notification, setNotification] = useApiNotification();
    const [persistNotification, setPersistNotification] =
        useApiPersistNotification();
    const [warning, setWarning] = useApiWarning();

    const handleClose = (
        event?: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason
    ) => {
        setError(undefined);
        setNotification(undefined);
        setPersistNotification(undefined);
        setWarning(undefined);
    };

    return (
        // <Snackbar
        //   open={error !== undefined}
        //   autoHideDuration={6000}
        //   onClose={handleClose}
        //   anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        // >
        //   <Alert
        //     onClose={handleClose}
        //     severity="error"
        //    // variant="filled"
        //     sx={{ width: "100%" }}
        //   >
        //     {error}
        //   </Alert>
        // </Snackbar>

        <CommonSnackbar
            messageType={error !== undefined ? "error" : warning ? "warning" : "success"}
            message={error ?? warning ?? notification ?? persistNotification ?? ""}
            onClose={handleClose}
            open={
                (error !== undefined ||
                    warning !== undefined ||
                    notification !== undefined ||
                    persistNotification !== undefined) ??
                false
            }
            persistent={persistNotification !== undefined || warning !== undefined}
        />
    );
};
export default AppSnackBar;
